<script>
export default {
  name: 'app'
}
</script>

<template>
  <main class="app">
    <section>
      <h1>Puredrift</h1>
      <h3>Puredrift is now closed.</h3>
      <p>For existing booking enquiries, please contact us.<br />Thank you for your interest.</p>
    </section>
  </main>
</template>

<style lang="less">
@import "~@/less/app";

.app {
  text-align: center;
  position: absolute;
  width: 300px;
  height: 200px;
  top: 50%;
  left: 50%;
  margin: -100px 0 0 -150px;

  h1 {
    background-image: url("~@/assets/logo.white.png");
    height: 42px;
    width: 56px;
    background-size: 56px;
    text-indent: -9999px;
    display: inline-block;
    margin: 0;
  }

  h3 {
    font: italic 500 1.2em "utopia-std", sans-serif;
    font-weight: 500;
    letter-spacing: normal;
  }

  p {
    font-size: 0.8em;
  }

  .obfuscate {
    cursor: pointer;
    unicode-bidi: bidi-override;
    direction: rtl;
    opacity: 0.8;

    &:hover {
      text-decoration: underline;
      opacity: 1;
    }
  }
}
</style>
